import { useEffect, useState } from "react";

/**
 * HeroDoorsCountdown — GIANT hero countdown to doors opening
 * (Teddy's rule: huge timer in the hero, never a thin bar).
 * Ticks live; once doors open it disappears entirely.
 * Day 2: repointed to Saturday noon doors after Day One wrapped.
 */

// Saturday July 18, 2026 at 12:00 PM ET (EDT = UTC-4) — final day doors.
const DOORS_DEADLINE_MS = Date.UTC(2026, 6, 18, 16, 0, 0);

const pad = (n: number) => String(n).padStart(2, "0");

const HeroDoorsCountdown = () => {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (now >= DOORS_DEADLINE_MS) return null;

  const diff = DOORS_DEADLINE_MS - now;
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff / 3_600_000) % 24);
  const minutes = Math.floor((diff / 60_000) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  const segments =
    days > 0
      ? [
          { value: String(days), label: days === 1 ? "Day" : "Days" },
          { value: pad(hours), label: "Hrs" },
          { value: pad(minutes), label: "Min" },
          { value: pad(seconds), label: "Sec" },
        ]
      : [
          { value: String(hours), label: "Hrs" },
          { value: pad(minutes), label: "Min" },
          { value: pad(seconds), label: "Sec" },
        ];

  return (
    <div className="mt-5 md:mt-7" role="timer" aria-label="Time left until doors open">
      <div className="flex items-baseline justify-center">
        {segments.map((seg, i) => (
          <div key={seg.label} className="flex items-baseline">
            {i > 0 && (
              <span className="text-yacht-yellow/60 font-bold leading-none text-[10vw] md:text-[5vw] mx-1 md:mx-2">
                :
              </span>
            )}
            <div className="flex flex-col items-center">
              <span className="text-yacht-yellow font-bold tabular-nums leading-none tracking-tight text-[13vw] md:text-[6.5vw]">
                {seg.value}
              </span>
              <span className="text-white/70 text-[10px] md:text-sm font-semibold tracking-[0.25em] uppercase mt-2">
                {seg.label}
              </span>
            </div>
          </div>
        ))}
      </div>
      <p className="text-white/90 text-sm md:text-lg font-medium tracking-[0.18em] uppercase mt-6">
        Until doors open · Saturday noon · One more day
      </p>
    </div>
  );
};

export default HeroDoorsCountdown;
